'use client';

import { useEffect } from 'react';
import { RegistrationStatus } from '@/types/pam-api';
import { sendLoginEvent, sendSignupEvent } from '@/features/analytics/datalayer/datalayer';
import { Webengage } from '@/features/webengage';
import useUser from '@/utils/use-user';
import { StorageKey } from './header/components/types';
const UserAnalyticsTracker = () => {
  const {
    user,
    isLoggedIn
  } = useUser();
  const registrationStatus = user?.registrationStatus;
  const userId = user?.id;
  useEffect(() => {
    if (!isLoggedIn || !userId || !registrationStatus) return;
    const isNewUser = registrationStatus === RegistrationStatus.NewUser;
    Webengage.identify(userId);
    if (isNewUser) {
      Webengage.signup();
      sendSignupEvent();
    } else {
      sendLoginEvent();
    }
  }, [isLoggedIn, registrationStatus, userId]);
  useEffect(() => {
    if (!user) return;
    const hasVisited = sessionStorage.getItem(StorageKey.HasSetAttributes);
    if (hasVisited === 'true') return;
    Webengage.setUserAttributes(user);
    sessionStorage.setItem(StorageKey.HasSetAttributes, 'true');
  }, [user]);
  return null;
};
export default UserAnalyticsTracker;